import { render, staticRenderFns } from "./fs-button.vue?vue&type=template&id=3f89449e&scoped=true"
import script from "./fs-button.vue?vue&type=script&lang=js"
export * from "./fs-button.vue?vue&type=script&lang=js"
import style0 from "./fs-button.vue?vue&type=style&index=0&id=3f89449e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f89449e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f89449e')) {
      api.createRecord('3f89449e', component.options)
    } else {
      api.reload('3f89449e', component.options)
    }
    module.hot.accept("./fs-button.vue?vue&type=template&id=3f89449e&scoped=true", function () {
      api.rerender('3f89449e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/buttons/fs-button.vue"
export default component.exports